import { ListFilter } from '@trufla-technology/trumarket-react-design-system';

type Props = {
  selected?: string[];
  onChange: (statuses: string[] | undefined) => void;
};

export const ClientsListFilter = ({ selected, onChange }: Props) => {
  const clientStatues = ['lead', 'vip', 'lost', 'client'];
  return (
    <ListFilter
      options={clientStatues.map((st) => ({
        label: st,
        value: st,
        checked: !!selected?.includes(st),
      }))}
      onChange={(types) => onChange(types.length ? types : undefined)}
    />
  );
};
